<h1 class="page-title mb-5"> عن المسئولية المجتمعية للشركات في قانون الاستثمار </h1>
<div>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-9">
                <ul class="list-unstyled">
                    <li class="mb-3">
                        يهدف قانون الاستثمار رقم 72 لعام 2017 إلى تعزيز جودة للاستثمار المحلي والأجنبي الذي يساهم في
                        التنمية المستدامة ويلتزم بسلوك الأعمال المسئول.
                    </li>
                </ul>

                <p class="mb-5">
                    وللمرة الأولي تضمن قانون الاستثمار مادة منفصلة لدعم المسئولية المجتمعية للمستثمر (المادة رقم
                    15).
                </p>

                <div class="section mb-5">
                    <h3 class="fw-bold mb-3">مادة (15) من قانون الاستثمار رقم (72) لسنة (2017)</h3>
                    <p>تضمنت المادة رقم 15:</p>
                    <ul class="custom-list">
                        <li>تحفيز نشاط المسئولية المجتمعية للشركات أيا كان حجمها أو غرضها أو شكلها القانوني.</li>
                        <li>حددت مجالات المسئولية المجتمعية للشركات: (حماية البيئة، الرعاية الصحية والاجتماعية
                            والثقافية أو مجالات تنمية أخري، التعليم الفني، التدريب والبحث العلمي)</li>
                        <li>حددت الحوافز الضريبية التي يمكن أن تحصل عليها الشركات.</li>
                        <li>إنشاء قائمة لأفضل الشركات القائمة بأنشطة تنمية مجتمعية.</li>
                        <li>حظر استخدام المشروعات أو البرامج أو الخدمات لنظام المسئولية المجتمعية لتحقيق أغراض
                            سياسية أو حزبية أو دينية أو تنطوي على التمييز بين المواطنين.</li>
                    </ul>
                    <div class="pdf-link mt-2">
                        <a href="../../assets/نص المادة 15 من قانون الاستثمار _المسئولية المجتمعية للمستثمر.pdf"
                            class="d-flex align-items-center gap-2 text-decoration-none text-dark">
                            <i class="fas fa-file-pdf text-danger fs-4"></i>
                            <span class="fw-bold text-decoration-underline">نص المادة 15 من قانون الاستثمار</span>
                        </a>
                    </div>
                </div>

                <div class="section mb-5">
                    <h3 class="fw-bold mb-3">مادة (2) من اللائحة التنفيذية لقانون الاستثمار رقم (72) لسنة (2017)
                    </h3>
                    <p>تضمنت اللائحة التنفيذية لقانون الاستثمار على تفصيل لتنفيذ "المسئولية المجتمعية للمستثمر".</p>
                    <p>تضمنت المادة رقم (2) من اللائحة التنفيذية توضيح إضافي حول مجالات المسئولية المجتمعية للمستثمر
                    </p>
                    <div class="pdf-link mt-2">
                        <a href="../../assets/نص المادة 2 من اللائحة التنفيذية لقانون الاستثمار.pdf"
                            class="d-flex align-items-center gap-2 text-decoration-none text-dark">
                            <i class="fas fa-file-pdf text-danger fs-4"></i>
                            <span class="fw-bold text-decoration-underline">نص المادة 2 من اللائحة التنفيذية لقانون
                                الاستثمار.pdf</span>
                        </a>
                    </div>
                </div>

                <div class="section mb-5">
                    <h3 class="fw-bold mb-3">مادة (3) من اللائحة التنفيذية لقانون الاستثمار رقم (72) لسنة (2017)
                    </h3>
                    <p>أقرت المادة (3) التزام المستثمر بأن يتقدم للهيئة العامة للاستثمار والمناطق الحرة بتقرير سنوي
                        مدعم بالمستندات لأنشطة التنمية المجتمعية.</p>
                    <div class="pdf-link mt-2">
                        <a href="../../assets/نص المادة 3 من اللائحة التنفيذية لقانون الاستثمار.pdf"
                            class="d-flex align-items-center gap-2 text-decoration-none text-dark">
                            <i class="fas fa-file-pdf text-danger fs-4"></i>
                            <span class="fw-bold text-decoration-underline">نص المادة 3 من اللائحة التنفيذية لقانون
                                الاستثمار.pdf</span>
                        </a>
                    </div>
                </div>

                <div class="section mb-5">
                    <h3 class="fw-bold mb-3">مادة (126) من اللائحة التنفيذية لقانون الاستثمار رقم (72) لسنة (2017)
                    </h3>
                    <p>أقرت المادة (126) التزام الشركات بتقديم بيان سنوي الي هيئة الاستثمار بمعلومات من ضمنها بيان
                        بالنظام الذي تتبعه في مجال التنمية المجتمعية.</p>
                    <div class="pdf-link mt-2">
                        <a href="../../assets/نص المادة 126 من اللائحة التنفيذية لقانون الاستثمار .pdf"
                            class="d-flex align-items-center gap-2 text-decoration-none text-dark">
                            <i class="fas fa-file-pdf text-danger fs-4"></i>
                            <span class="fw-bold text-decoration-underline">نص المادة 126 من اللائحة التنفيذية
                                لقانون الاستثمار .pdf</span>
                        </a>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <app-fix-how-we-can-help></app-fix-how-we-can-help>
            </div>
        </div>
    </div>
</div>